var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurmissiondeco1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 787,
    height: 211,
    viewBox: "0 0 787 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M786.059 211.001C786.059 211.001 719.236 97.1192 578.083 97.1192C436.93 97.1192 365.514 77.2858 330.314 54.2534C295.115 31.2211 197.42 -26.3597 54.7655 13.9469C-87.8892 54.2534 -190 211.001 -190 211.001H786.059Z",
    fill: "#ADE5FF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 369.157,
    cy: 66.9125,
    rx: 21.1573,
    ry: 22.9125,
    fill: "#FFC727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurmissiondeco1);
export default __webpack_public_path__ + "static/media/ourmissiondeco-1.250fa08ae9f5106c18ff6ecb664e5749.svg";
export { ForwardRef as ReactComponent };